import actions from './actions';

const { requestFloorsBegin } = actions;

export default {
  requestFloorsBegin,
};
